// Non-reactive snapshot of the catalog list, kept alive for as long as the SPA
// stays loaded. Navigating into an item unmounts Home and throws away every ref
// the list hooks held, so without this the list came back empty, at offset 0 and
// scrolled to the top. Restoring from here lets the browser back button land the
// user exactly where they left off.
//
// Deliberately a plain module object rather than state/context: it is read once
// while mounting and written on scroll, and neither should trigger a rerender.

const catalogCache = {
  key: null, // serialised query the cached items belong to
  items: [],
  offset: 0,
  count: 0,
  scrollY: 0,
};

// The cache is only valid for the exact query it was filled with — a different
// sort, search term or filter set must start from an empty list.
export const catalogCacheKey = ({ searchValue, sort, filters }) => JSON.stringify({
  searchValue: searchValue || '',
  sort,
  filters: (filters || []).map(({ type, id }) => `${type}:${id}`),
});

export const resetCatalogCache = () => {
  catalogCache.key = null;
  catalogCache.items = [];
  catalogCache.offset = 0;
  catalogCache.count = 0;
  catalogCache.scrollY = 0;
};

export default catalogCache;
